import { SolTag, SolText } from '@sol/components';
import {
  ENGAGEMENT_REQUEST_STATUS_CONFIG,
  EngagementRequestStatus,
  EngagementRequestSubscriptionType,
  SUBSCRIPTION_TYPE_CONFIG,
} from '../models/engagement-request';

/** Engagement-request enum to SolTag mappings. */
export class AsmEngagementRequestTagTools {
  private constructor() {}

  /** Convert a status to a colored SolTag. */
  public static toStatusTag(status: EngagementRequestStatus): SolTag {
    const config = ENGAGEMENT_REQUEST_STATUS_CONFIG[status];
    if (!config) {
      return SolTag.of(SolText.ofRaw(status)).withColor('grey');
    }
    return SolTag.of(SolText.of(config.label)).withColor(config.color);
  }

  /** Convert a subscription type to a colored SolTag. Unknown BE values fall back
   * to a generic grey tag showing the raw code. */
  public static toSubscriptionTag(subscriptionType: EngagementRequestSubscriptionType): SolTag {
    const config = SUBSCRIPTION_TYPE_CONFIG[subscriptionType];
    if (!config) {
      return SolTag.of(SolText.ofRaw(subscriptionType)).withColor('grey');
    }
    return SolTag.of(SolText.of(config.label)).withColor(config.color);
  }
}
